import React, { useEffect } from 'react';

import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';

import { CDashboard } from 'components/Visualization';
import { dashboardWidgets1 } from 'containers/Compliance/Components/ComplianceDashboard/config';
import { selectCompliance } from 'containers/Compliance/selectors';

import { actions } from '../../slice';

interface Props {
  environmentId: string;
}

export const ComplianceDashboard: React.FC<Props> = props => {
  const dispatch = useDispatch();
  const { environmentId } = props;

  const { selectedBlueprint } = useSelector(selectCompliance);

  useEffect(() => {
    const startDate = dayjs().subtract(30, 'days').format('YYYY-MM-DD');
    const endDate = dayjs().format('YYYY-MM-DD');
    if (!isEmpty(selectedBlueprint)) {
      dispatch(
        actions.getComplianceSummary({
          q: { blueprintId: selectedBlueprint?.id, environmentId },
        }),
      );
      dispatch(
        actions.getHistoricalTrend({
          q: {
            blueprintId: selectedBlueprint?.id,
            startDate,
            endDate,
            environmentId,
          },
        }),
      );
      dispatch(
        actions.getViolationsByAccount({
          q: { blueprintId: selectedBlueprint?.id, environmentId },
        }),
      );
    }
  }, [dispatch, selectedBlueprint, environmentId]);

  return <CDashboard dashboardWidgets={dashboardWidgets1} />;
};
